import { AvailableLanguages } from '../types/language.types'

export const daysOfWeek: Record<AvailableLanguages, string[]> = {
  fr: ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'],
  en: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
}
export const months: Record<AvailableLanguages, string[]> = {
  fr: [
    'Janvier',
    'Février',
    'Mars',
    'Avril',
    'Mai',
    'Juin',
    'Juillet',
    'Août',
    'Septembre',
    'Octobre',
    'Novembre',
    'Décembre'
  ],
  en: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ]
}

/**
 * Array of years from 50 years ago to 50 years from now
 * @example Now: 2024 => [1974, 1975, ..., 2074]
 */
export const years = Array.from({ length: 100 }, (_, i) => new Date().getFullYear() - 50 + i)

/**
 * @example [0, 1, 2, 3, ..., 12]
 */
export const numberOfYearsInLanguage = Array.from({ length: 13 }, (_, i) => i)

/**
 * Array of years from 50 years ago to now
 * @example Now: 2024 => [1974, 1975, ..., 2024]
 */
export const yearsBeforeNow = Array.from({ length: 51 }, (_, i) => new Date().getFullYear() - i)
